var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShowName(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4821_150727)",
    filter: "url(#filter0_i_4821_150727)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.09082,
    y: 24.8867,
    width: 21.8182,
    height: 5.11364,
    rx: 1.43182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6495 23.2213C14.8385 23.0168 15.1617 23.0168 15.3507 23.2213L17.8029 25.8759C18.0852 26.1816 17.8684 26.677 17.4523 26.677H12.5479C12.1317 26.677 11.9149 26.1816 12.1973 25.8759L14.6495 23.2213Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1593 21.378C7.96765 12.4019 6.81836 11.4807 6.81836 8.18182C6.81836 3.66311 10.4815 0 15.0002 0C19.5189 0 23.182 3.66311 23.182 8.18182C23.182 11.4807 22.0327 12.4019 15.841 21.378C15.4347 21.9649 14.5656 21.9649 14.1593 21.378ZM15.0002 11.5909C16.883 11.5909 18.4093 10.0646 18.4093 8.18182C18.4093 6.29902 16.883 4.77273 15.0002 4.77273C13.1174 4.77273 11.5911 6.29902 11.5911 8.18182C11.5911 10.0646 13.1174 11.5909 15.0002 11.5909Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9492 27.8366C12.9492 27.7141 12.9901 27.6147 13.0717 27.5384C13.1552 27.462 13.2591 27.4238 13.3833 27.4238C13.5094 27.4238 13.6133 27.462 13.695 27.5384C13.7784 27.6147 13.8201 27.7141 13.8201 27.8366C13.8201 27.9574 13.7793 28.0559 13.6976 28.1323C13.6159 28.2069 13.5112 28.2441 13.3833 28.2441C13.2573 28.2441 13.1534 28.2069 13.0717 28.1323C12.9901 28.0559 12.9492 27.9574 12.9492 27.8366Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5366 27.8366C14.5366 27.7141 14.5774 27.6147 14.6591 27.5384C14.7425 27.462 14.8464 27.4238 14.9707 27.4238C15.0968 27.4238 15.2006 27.462 15.2823 27.5384C15.3658 27.6147 15.4075 27.7141 15.4075 27.8366C15.4075 27.9574 15.3667 28.0559 15.285 28.1323C15.2033 28.2069 15.0985 28.2441 14.9707 28.2441C14.8446 28.2441 14.7408 28.2069 14.6591 28.1323C14.5774 28.0559 14.5366 27.9574 14.5366 27.8366Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1239 27.8366C16.1239 27.7141 16.1648 27.6147 16.2464 27.5384C16.3299 27.462 16.4338 27.4238 16.5581 27.4238C16.6841 27.4238 16.788 27.462 16.8697 27.5384C16.9531 27.6147 16.9949 27.7141 16.9949 27.8366C16.9949 27.9574 16.954 28.0559 16.8723 28.1323C16.7907 28.2069 16.6859 28.2441 16.5581 28.2441C16.432 28.2441 16.3281 28.2069 16.2464 28.1323C16.1648 28.0559 16.1239 27.9574 16.1239 27.8366Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_4821_150727",
    x: 0,
    y: 0,
    width: 30,
    height: 31,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4821_150727"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4821_150727"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowName);
export default __webpack_public_path__ + "static/media/show_name.4b0f30be9d994a7172aab2a91ac84071.svg";
export { ForwardRef as ReactComponent };